import ContentCenter from "../../ui/ContentCenter";
import { useEffect, useRef, useState } from "react";
import styled from "styled-components";

const easyImages=[
    "/penacrobatics/pen-easy-1.png",
    "/penacrobatics/pen-easy-2.png",
    "/penacrobatics/pen-easy-3.png",
]

const mediumImages=[
    "/penacrobatics/pen-med-1.png",
    "/penacrobatics/pen-med-2.png",
    "/penacrobatics/pen-med-3.png",
];

const hardImages=[
    "/penacrobatics/pen-hard-1.png",
    "/penacrobatics/pen-hard-2.png",
    "/penacrobatics/pen-hard-3.png",
    "/penacrobatics/pen-hard-4.png",
];

const Image = styled.img`
    transition: opacity 1s;
`

export default ({ started, level }: any) => {
    const [imgIndex, setImgIndex] = useState(0);
    const imgRef: any = useRef<HTMLImageElement>(null);
    const fadeInTimerRef: any = useRef(null);
    const fadeOutTimerRef: any = useRef(null);

    const images = level === 1 ? easyImages : level === 2 ? mediumImages : hardImages;

    const handleImageSwitch = () => {
      if (imgRef.current) {
        imgRef.current.style.transition = "opacity 1s";
          fadeOutTimerRef.current = setTimeout(
            () => (imgRef.current.style.opacity = "0"),
            2000
          );
          fadeInTimerRef.current = setTimeout(() => {
            imgRef.current.style.opacity = "1";
            setImgIndex(imgIndex + 1);
          }, 3500);
        if (imgIndex === images.length) setImgIndex(0);
      }
    };

    const cleanUp = () => {
        if (fadeInTimerRef.current) clearTimeout(fadeInTimerRef.current)
        if (fadeOutTimerRef.current) clearTimeout(fadeOutTimerRef.current)
    }

    const handleLevelSwitch = () => {
        if (imgRef.current) {
        imgRef.current.style.transition = "opacity 0s"
        imgRef.current.style.opacity = "1"
        }
        if (fadeInTimerRef.current) clearTimeout(fadeInTimerRef.current)
        if (fadeOutTimerRef.current) clearTimeout(fadeOutTimerRef.current)
    }
    
    useEffect(() => {
      if (started) handleImageSwitch() 
      else setImgIndex(0);
      return cleanUp;
    }, [imgIndex, started]);

    useEffect(() => {
        handleLevelSwitch();
        return cleanUp;
    },[level])


  return (
    <ContentCenter style={{height: "100%"}}>
        <Image ref={imgRef} src={images[imgIndex]} />
    </ContentCenter>
  );
};
